import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  readMessage,
  readPopupMessage,
  removeBannerMessage,
  removeMessage,
} from "@services/messages/services";
import { type IMessage } from "@services/messages/types";
import { queryClient } from "@/queryClient";

export const useReadMessageMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (messageId: IMessage["messageId"]) =>
      readMessage(messageId).then(() => messageId),
    onSuccess: (messageId) => {
      queryClient.setQueryData<IMessage[]>(["messages"], (messages) =>
        (messages ?? []).map((message) => ({
          ...message,
          isRead: message.messageId === messageId ? true : message.isRead,
        })),
      );
    },
  });
};

export const useRemoveMessageMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (messageId: IMessage["messageId"]) =>
      removeMessage(messageId).then(() => messageId),
    onSuccess: (messageId) => {
      queryClient.setQueryData<IMessage[]>(["messages"], (messages) =>
        (messages ?? []).filter((m) => m.messageId !== messageId),
      );
    },
  });
};

export const useReadPopupMutation = () =>
  useMutation({
    mutationFn: readPopupMessage,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["popupMessages"],
      });
    },
  });

export const useRemoveBannerMessageMutation = (bannerType: string) =>
  useMutation({
    mutationFn: () => removeBannerMessage(bannerType),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["bannerMessages"],
      });
    },
  });
